module.exports = __webpack_public_path__ + "7530ea8168bcfca913c14a9666d3d783.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/holly.png
// module id = 2775
// module chunks = 0